import { render } from "./PlaExpedicaoStatusSelect.vue?vue&type=template&id=5ce89ca4"
import script from "./PlaExpedicaoStatusSelect.vue?vue&type=script&lang=js"
export * from "./PlaExpedicaoStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__